import { Component, EnvironmentInjector, inject, runInInjectionContext } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';

@Component({
    selector: 'app-wedding-rsvp',
    templateUrl: './wedding-rsvp.component.html',
    styleUrls: ['./wedding-rsvp.component.scss'],
    standalone: false
})
export class WeddingRsvpComponent {
  guestName = '';
  attendance = '';
  guests = 1;
  otherGuestNames: string[] = [];
  rsvpList = [];
  rsvpSubmitted = false;
  submitAttempted = false;

  private injector = inject(EnvironmentInjector);

  constructor(
    private db: AngularFireDatabase
  ) {
    this.getRSVPList();
  }

  private inCtx<T>(fn: () => T): T {
    return runInInjectionContext(this.injector, fn);
  }

  onSubmit() {
    this.submitAttempted = true;
    if (!this.isFormValid()) {
      return;
    }
    // Add your submit logic
    const formData = {
      name: this.guestName,
      attendance: this.attendance,
      guestCount: this.guests,
      otherGuestNames: this.otherGuestNames
    };
    this.sendMessage(formData).then(() => {
      this.rsvpSubmitted = true;
    });
  }


  sendMessage(data){
    return this.inCtx(() => this.db.list('/wedding-rsvp').push(data));
  }
  getRSVPList(){
    this.inCtx(() => this.db.list('/wedding-rsvp').valueChanges()).subscribe(list => {
      this.rsvpList = list;
    });
  }

  setGuests(count: number) {
    this.guests = count;
    // Ensure otherGuestNames has the correct length
    if (count > 1) {
      while (this.otherGuestNames.length < count - 1) {
        this.otherGuestNames.push('');
      }
      while (this.otherGuestNames.length > count - 1) {
        this.otherGuestNames.pop();
      }
    } else {
      this.otherGuestNames = [];
    }
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }

  updateOtherGuestName(value: string, i: number) {
    this.otherGuestNames[i] = value;
  }

  preventNonNumericInput(event: KeyboardEvent) {
    // Allow: backspace, delete, tab, escape, enter, arrows
    if ([
      'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
      'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
    ].indexOf(event.key) !== -1) {
      return;
    }
    // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if ((event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].indexOf(event.key.toLowerCase()) !== -1) {
      return;
    }
    // Block non-numeric
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  isFormValid(): boolean {
    if (!this.guestName || !this.attendance || !this.guests) {
      return false;
    }
    if (this.guests > 1) {
      // All additional guest names must be filled and not just whitespace
      return this.otherGuestNames.length === this.guests - 1 && this.otherGuestNames.every(name => name && name.trim().length > 0);
    }
    return true;
  }
}
